import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-stripe-cancel',
  templateUrl: './stripe-cancel.component.html',
  styleUrls: ['./stripe-cancel.component.scss']
})
export class StripeCancelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
